import Pusher from 'pusher-js'

import { PUSHER_APP_KEY, PUSHER_CLUSTER } from '@webapp/infrastructure/envs'

export const pusher = new Pusher(PUSHER_APP_KEY, {
  cluster: PUSHER_CLUSTER,
  disableStats: true,
  forceTLS: true,
})
